export default __webpack_public_path__ + "static/media/thumb-up2.96728463.svg";